import {useId} from 'react'
import PropTypes from 'prop-types'
import {Close} from '@mui/icons-material'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import {
  StyledModal,
  StyledCloseButton,
  StyledDialogTitle,
  StyledModalHeaderBox,
  StyledModalTitleBox,
  StyledModalSpacer
} from './ModalStyle'

const Modal = ({
  aria,
  title,
  children,
  primaryAction,
  open,
  onClose,
  header,
  maxWidth = 'sm',
  disableBackdropClick = false
}) => {
  const fallbackLabelId = useId()
  const labelId = aria?.labelledBy || `modal-title-${fallbackLabelId}`
  const hasLabelElement = !!header || !!title

  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return
    }
    onClose(event, reason)
  }

  return (
    <StyledModal
      open={open}
      onClose={handleClose}
      aria-labelledby={hasLabelElement ? labelId : undefined}
      fullWidth
      maxWidth={maxWidth}
    >
      {header ? (
        <StyledModalHeaderBox id={labelId}>
          {header}
          <StyledCloseButton aria-label='close' onClick={handleClose} variant='text' disableRipple>
            <Close />
          </StyledCloseButton>
        </StyledModalHeaderBox>
      ) : (
        title && (
          <StyledModalTitleBox>
            <StyledDialogTitle id={labelId}>{title}</StyledDialogTitle>
            <StyledCloseButton aria-label='close' onClick={handleClose} variant='text' disableRipple>
              <Close />
            </StyledCloseButton>
          </StyledModalTitleBox>
        )
      )}
      {!title && <StyledModalSpacer />}
      <DialogContent dividers={!!title}>{children}</DialogContent>
      {primaryAction && (
        <DialogActions>
          <Button onClick={primaryAction.onClick}>{primaryAction.label}</Button>
        </DialogActions>
      )}
    </StyledModal>
  )
}

Modal.propTypes = {
  aria: PropTypes.shape({
    labelledBy: PropTypes.string.isRequired
  }),
  title: PropTypes.string,
  header: PropTypes.element,
  children: PropTypes.node.isRequired,
  primaryAction: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  disableBackdropClick: PropTypes.bool
}

export default Modal
